/**
 * 页面动画控制器
 * 使用 Intersection Observer 实现滚动触发动画
 */

(function() {
  'use strict';

  // 检查浏览器是否支持 Intersection Observer
  if (!('IntersectionObserver' in window)) {
    // 不支持的情况下，直接显示所有元素
    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      el.classList.add('animated');
    });
    return;
  }

  // 动画配置
  const animationConfig = {
    root: null,
    rootMargin: '0px 0px -100px 0px', // 提前100px触发
    threshold: 0.1 // 元素10%可见时触发
  };

  // 创建 Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        // 可选：动画触发后停止观察（节省性能）
        observer.unobserve(entry.target);
      }
    });
  }, animationConfig);

  // 观察所有需要动画的元素
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => {
      observer.observe(el);
    });
  }

  // 为产品详情页特定元素添加滚动动画
  function initProductPageAnimations() {
    // 产品介绍区域 - 使用content和image-wrapper
    const introContent = document.querySelector('.product-introduction-cowboy__content');
    const introImage = document.querySelector('.product-introduction-cowboy__image-wrapper');
    
    if (introContent) {
      introContent.classList.add('animate-on-scroll', 'animate-fade-in-up');
      observer.observe(introContent);
    }
    
    if (introImage) {
      introImage.classList.add('animate-on-scroll', 'animate-slide-in-right');
      observer.observe(introImage);
    }

    // 功能图标项
    const featureIconItems = document.querySelectorAll('.product-features-icons-cowboy__item');
    featureIconItems.forEach((item, index) => {
      item.classList.add('animate-on-scroll', 'animate-scale-in');
      observer.observe(item);
    });

    // 功能详情项
    const featureItems = document.querySelectorAll('.product-features-detail__item');
    featureItems.forEach((item, index) => {
      item.classList.add('animate-on-scroll', 'animate-fade-in-up');
      // 为奇数/偶数项应用不同的动画方向
      const imageWrapper = item.querySelector('.product-features-detail__item-image');
      if (imageWrapper) {
        if (index % 2 === 0) {
          imageWrapper.classList.add('animate-on-scroll', 'animate-slide-in-left');
        } else {
          imageWrapper.classList.add('animate-on-scroll', 'animate-slide-in-right');
        }
        observer.observe(imageWrapper);
      }
      observer.observe(item);
    });

    // 客户评价项
    const testimonialItems = document.querySelectorAll('.product-testimonial-cowboy__item, [class*="review_"]');
    testimonialItems.forEach((item, index) => {
      item.classList.add('animate-on-scroll', 'animate-blur-in');
      observer.observe(item);
    });
  }

  // 为About页面特定元素添加滚动动画
  function initAboutPageAnimations() {
    const aboutSections = document.querySelectorAll('.about-section, .process, .partners-section');
    
    aboutSections.forEach((section, index) => {
      const content = section.querySelector('.about-section__content, .process_text_group, .partners-section__content');
      const image = section.querySelector('.about-section__image, .process_image');
      
      if (content) {
        content.classList.add('animate-on-scroll', 'animate-fade-in-up');
        observer.observe(content);
      }
      
      if (image) {
        image.classList.add('animate-on-scroll', 'animate-slide-in-right');
        observer.observe(image);
      }
    });
  }

  // 为Blog页面特定元素添加滚动动画
  function initBlogPageAnimations() {
    const blogItems = document.querySelectorAll('.blog-list-cowboy__item');
    
    blogItems.forEach((item, index) => {
      item.classList.add('animate-on-scroll', 'animate-fade-in-up');
      observer.observe(item);
    });
  }

  // 视差滚动效果
  function initParallaxEffect() {
    const parallaxElements = document.querySelectorAll('.parallax-element');
    
    if (parallaxElements.length === 0) return;

    let ticking = false;

    function updateParallax() {
      const scrollY = window.pageYOffset;
      
      parallaxElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementTop = rect.top + scrollY;
        const elementHeight = rect.height;
        const windowHeight = window.innerHeight;
        
        // 元素在视口中时应用视差效果
        if (rect.top < windowHeight && rect.bottom > 0) {
          const parallaxSpeed = el.dataset.parallaxSpeed || 0.5;
          const offset = (scrollY - elementTop) * parallaxSpeed;
          el.style.transform = `translateY(${offset}px)`;
        }
      });
      
      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
  }

  // 页面加载完成后初始化
  function init() {
    // 标记页面已加载
    document.documentElement.classList.add('page-loaded');

    // 初始化滚动动画
    initScrollAnimations();

    // 根据页面类型初始化特定动画
    if (document.body.classList.contains('template-product') || 
        window.location.pathname.includes('/products/')) {
      initProductPageAnimations();
    }

    if (document.body.classList.contains('template-page') && 
        (window.location.pathname.includes('/pages/about') || 
         document.querySelector('.about-hero-cowboy'))) {
      initAboutPageAnimations();
    }

    if (document.body.classList.contains('template-blog') || 
        window.location.pathname.includes('/blogs/')) {
      initBlogPageAnimations();
    }

    // 初始化视差效果
    initParallaxEffect();
  }

  // DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 处理动态加载的内容（如Ajax加载的文章列表）
  window.addEventListener('pageAnimations:refresh', function() {
    initScrollAnimations();
    initBlogPageAnimations();
  });

})();

